import { Font, StyleSheet } from '@react-pdf/renderer'

Font.register({
  family: 'Inter',
  fonts: [
    { src: '/fonts/Inter-Medium.ttf', fontWeight: 500 },
    { src: '/fonts/Inter-Regular.ttf', fontWeight: 400 },
    { src: '/fonts/Inter-Italic.ttf', fontWeight: 400, fontStyle: 'italic' },
    { src: '/fonts/Inter-Light.ttf', fontWeight: 300 },
  ],
})

Font.registerEmojiSource({
  format: 'png',
  url: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.0.1/img/apple/64/',
  withVariationSelectors: true,
})

export const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: 'Inter',
    backgroundColor: '#F7F7FB',
  },
  pageTitle: {
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 500,
    marginBottom: 30,
  },
  linkIcon: {
    width: 6,
    height: 6,
    marginLeft: 2,
  },
  avatar: {
    width: 26,
    height: 26,
    borderRadius: 13,
  },
  block: {
    gap: 10,
    marginBottom: 20,
  },
  header: {
    flexDirection: 'row',
    gap: 10,
  },
  accountWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  title: {
    fontSize: 12,
    fontWeight: 500,
  },
  card: {
    paddingHorizontal: 12,
    paddingVertical: 13,
    backgroundColor: '#fff',
    borderRadius: 5,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
  },
  flex: {
    flex: 1,
  },
  headerTitle: {
    fontSize: 8,
    fontWeight: 500,
    marginBottom: 5,
  },
  accountName: {
    fontSize: 7,
  },
  headerSubtitle: {
    fontSize: 8,
    marginBottom: 2,
  },
  headerDesc: {
    color: '#898C9A',
    fontSize: 6,
    marginBottom: 5,
  },
  linkWrapper: {
    marginTop: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  link: {
    fontWeight: 300,
    fontSize: 6,
    color: '#898C9A',
    textDecoration: 'underline',
  },
})
